import { Fragment } from 'react';
import Image from 'next/image';

import { ClinicInsuranceProvider } from '@models/clinic-list';
import { Bottomsheet } from '@com/modal/containers/Bottomsheet';
import NextImage from '@com/_core/NextImage';

type SupportedInsurancesBottomSheetProps = {
  insurances: ClinicInsuranceProvider[];
};

const SupportedInsurancesBottomSheet = ({
  insurances,
}: SupportedInsurancesBottomSheetProps) => {
  return (
    <Bottomsheet
      height="auto"
      maxHeight="35dvh"
      hasCloseButton
      title="بیمه‌های تحت‌پوشش"
      titleClassName="text-Label/Medium text-content-primary"
      className="bg-surface-primary !overflow-y-auto border border-b border-border-secondary"
    >
      <div className="flex flex-col gap-y-3 px-4 pb-4">
        {insurances.map((insurance) => (
          <Fragment key={insurance.id}>
            <div className="flex items-center gap-x-3 py-2">
              <div className="flex h-10 w-10 shrink-0 items-center justify-center overflow-hidden rounded-full bg-surface-secondary">
                {insurance.logoUrl ? (
                  <NextImage
                    src={insurance.logoUrl}
                    alt={insurance.name}
                    width={40}
                    height={40}
                  />
                ) : (
                  <Image
                    src="/images/emptyImage.png"
                    alt="insurance placeholder image"
                    width={40}
                    height={40}
                  />
                )}
              </div>
              <span className="text-Label/Medium text-content-primary">
                {insurance.name}
              </span>
            </div>
          </Fragment>
        ))}
      </div>
    </Bottomsheet>
  );
};

export default SupportedInsurancesBottomSheet;
